import $ from 'jquery';

// Mobile nav toggle
$('#nav-mobile-toggle').on('click', function() {
	$('.nav-mobile-container').toggleClass('is-open');
	$('.icon-one').toggleClass('open');
	$('body').toggleClass('noscroll');
});
